import React from "react";
import ReactDOM from "react-dom";
import Login from "srcDir/components/Login";
import fetch from "isomorphic-fetch";
import { notification } from "antd";
import Storage from "store2";
import { urlAppendQuery } from "./tools";
import CryptoJS from "crypto-js";

import { goaiBaseUrl, goaiApiKey, goaiApiSecret } from "./goaiConfig";



const generateNonce = (len = 16) => {
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  let result = ''
  for (let i = 0; i < len; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

const generateTimestamp = () => {
  return String(Date.now())
}

const calculateSignature = (method, path, timestamp, nonce, body, secret) => {
  const raw = method + '\n' + path + '\n' + timestamp + '\n' + nonce + '\n' + body
  const signature = CryptoJS.HmacSHA256(raw, secret).toString(CryptoJS.enc.Hex).toLowerCase()
  return signature
}

function checkStatus(response) {
  // if (window.navigate) window.navigate.push("/500");
  const dvToken = response.headers.get("duplication_verify_token");
  if (dvToken) {
    Storage.set("dv_token", dvToken);
  }
  if (response.status >= 200 && response.status <= 400) {
    return response;
  }

  if (
    response.status == 401 &&
    response.url.indexOf("login?method=platform-username-password-login") != -1
  ) {
    const error = new Error("用户名或密码错误");
    error.response = response;
    throw error;
  }
  if (response.status === 401 || response.status === 403) {
    ReactDOM.render(<Login />, document.getElementById("root"));
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */


function send(url, options, autoTips, isLogin) {
  const Authorization = Storage.get("AuthorizationBearer");
  const defaultOptions = {
    headers: !isLogin
      ? {
          Authorization: Authorization || "",
        }
      : {},

    };
  const newOptions = { ...defaultOptions, ...options };
  if (newOptions.method === "POST" || newOptions.method === "PUT") {
    newOptions.headers = {
      Accept: "application/json",
      mode: "no-cors",
      "Content-Type": "application/json; charset=utf-8",
      ...newOptions.headers,
    };
    newOptions.body = JSON.stringify(newOptions.body);
  }
  if (newOptions.method === "UPLOAD") {
    newOptions.method = "POST";
  }
  // 拼接路径参数
  let newUrl = url;
  if (options && options.params) {
    newUrl = urlAppendQuery(url, {
      ...options.params,
    });
  }
  const checkBiz = (response) =>
    response.json().then((res) => {
      if (autoTips) {
        if (!res.success) {
          notification.error({
            message: res.msg,
          });
        } else if (res.msg) {
          notification.success({
            message: res.msg,
          });
        }
      }
      return res;
    });
    return fetch(newUrl, newOptions)
    .then(checkStatus)
    .then(checkBiz)
    .catch((error) => {
      return error;
    });
}

function goAiSend(url, method="POST", data, ) {

  const timestamp = generateTimestamp()
  const nonce = generateNonce()
  const body = (method !== 'GET' && data !== null) ? JSON.stringify(data) : ''

  const signature = calculateSignature(method, '/api/public' + url, timestamp, nonce, body, goaiApiSecret)
  const urls = goaiBaseUrl + url

  if (data !== null && method !== 'GET') {
    data.body = JSON.stringify(data)
  }
console.log({
      'Content-Type': 'application/json',
      'X-API-Key': goaiApiKey,
      'X-Timestamp': timestamp,
      'X-Nonce': nonce,
      'X-Signature': signature,
    });return
  fetch(urls, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': goaiApiKey,
      'X-Timestamp': timestamp,
      'X-Nonce': nonce,
      'X-Signature': signature,
    },
    body: body,
  }).then(async response => {
    console.log('[OCR Upload] Response status:', response.status)
    const text = await response.text()
    console.log('[OCR Upload] Response text:', text.substring(0, 500))
    try {
      return JSON.parse(text)
    } catch (e) {
      throw new Error('服务器返回非JSON: ' + text.substring(0, 200))
    }
  }).then(responseJson => {
    // if (responseJson.success === true) {
    //   if (localOcrResult && !responseJson.ocr_content) {
    //     responseJson.ocr_content = localOcrResult.ocr_content
    //     responseJson.extracted_name = localOcrResult.extracted_name
    //     responseJson.source = 'ios-vision'
    //   }
    //   resolve(responseJson)
    // } else {
    //   if (localOcrResult) {
    //     console.log('[OCR] 服务器上传失败，使用本地OCR结果')
    //     resolve(localOcrResult)
    //   } else {
    //     reject(new Error(responseJson.message || '上传失败'))
    //   }
    // }
  }).catch(error => {
    console.error('[OCR] upload error:', error.message || error)
    // if (localOcrResult) {
    //   console.log('[OCR] 网络失败，使用本地OCR结果')
    //   resolve(localOcrResult)
    // } else {
    //   reject(error)
    // }
  })
}


export default {
  GET(url, options, autoTips) {
    if (typeof options !== "object") {
      return send(url, { method: "GET" }, options);
    }
    return send(url, { ...options, method: "GET" }, autoTips);
  },
  POST(url, options, autoTips, isLogin) {
    if (typeof options !== "object") {
      return send(url, { method: "POST" }, options, isLogin);
    }
    return send(url, { ...options, method: "POST" }, autoTips, isLogin);
  },
  PUT(url, options, autoTips) {
    if (typeof options !== "object") {
      return send(url, { method: "PUT" }, options);
    }
    return send(url, { ...options, method: "PUT" }, autoTips);
  },
  UPLOAD(url, options, autoTips) {
    if (typeof options !== "object") {
      return send(url, { method: "UPLOAD" }, options);
    }
    return send(url, { ...options, method: "UPLOAD" }, autoTips);
  },
  DELETE(url, options, autoTips) {
    if (typeof options !== "object") {
      return send(url, { method: "DELETE" }, options);
    }
    return send(url, { ...options, method: "DELETE" }, autoTips);
  },
  GOAI(url, method, options) {
    return goAiSend(url, method, options);
  },
};


// WEBPACK FOOTER //
// ./src/util/request.js